<span class="label"
	  [class.label-icd9]="isCodeSetICD9()"
	  [class.label-icd10]="isCodeSetICD10()"
	  [class.label-snmd]="isCodeSetSNOMED()">
	{{practiceDiagnosis?.codeSet?.label}}
</span>
<span class="margin-left-sm">
	{{getDescription()}}
</span>
